var GOOGLE_MAPS_LIBRARIES, GOOGLE_MAPS_VERSION, GoogleMaps, MAP_PROXY_CHANNEL, MAP_PROXY_HOST_EU, MAP_PROXY_HOST_NA, callbacks, getMapProxyHost, loaded, loading;

MAP_PROXY_CHANNEL = 'layout-service';

MAP_PROXY_HOST_NA = '//mapproxy.groupon.com';

MAP_PROXY_HOST_EU = '//mapproxy-eu.groupon.com';

GOOGLE_MAPS_VERSION = 3;

GOOGLE_MAPS_LIBRARIES = ['geometry'];

loading = false;

callbacks = [];

loaded = function() {
  var cb, i, len, results;
  results = [];
  for (i = 0, len = callbacks.length; i < len; i++) {
    cb = callbacks[i];
    results.push(cb());
  }
  return results;
};

getMapProxyHost = function() {
  var country;
  country = document.head.getAttribute('data-country');
  if (country === 'US' || country === 'CL' || country === 'CO' || country === 'MX' || country === 'PA' || country === 'PE' || country === 'PR' || country === 'UY') {
    return MAP_PROXY_HOST_NA;
  } else {
    return MAP_PROXY_HOST_EU;
  }
};

module.exports = GoogleMaps = {
  load: function(cb) {
    var callbackName, query, ref;
    if (cb == null) {
      cb = function() {};
    }
    if (((ref = window.google) != null ? ref.maps : void 0) != null) {
      return cb();
    }
    callbacks.push(cb);
    if (loading) {
      return;
    }
    loading = true;
    callbackName = 'layoutServiceGoogleMapsCallback';
    window[callbackName] = loaded;
    query = $.param({
      sensor: false,
      v: GOOGLE_MAPS_VERSION,
      libraries: GOOGLE_MAPS_LIBRARIES.join(','),
      callback: callbackName,
      region: document.head.getAttribute('data-country') || 'US',
      language: document.head.getAttribute('data-language') || 'en-US',
      channel: MAP_PROXY_CHANNEL
    });
    return $.getScript((getMapProxyHost()) + "/maps/api/js?" + query).fail(function() {
      return cb(new Error('Unable to load Google Maps Library'));
    });
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL21vZHVsZXMvZ29vZ2xlX21hcHMvZnJvbnRlbmQvZ29vZ2xlX21hcHMuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL21vZHVsZXMvZ29vZ2xlX21hcHMvZnJvbnRlbmQvZ29vZ2xlX21hcHMuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdBLElBQUE7O0FBQUEsaUJBQUEsR0FBb0I7O0FBQ3BCLGlCQUFBLEdBQW9COztBQUNwQixpQkFBQSxHQUFvQjs7QUFFcEIsbUJBQUEsR0FBc0I7O0FBQ3RCLHFCQUFBLEdBQXdCLENBQUMsVUFBRDs7QUFFeEIsT0FBQSxHQUFVOztBQUNWLFNBQUEsR0FBWTs7QUFFWixNQUFBLEdBQVMsU0FBQTtBQUNQLE1BQUE7QUFBQTtPQUFBLDJDQUFBOztpQkFBQSxFQUFBLENBQUE7QUFBQTs7QUFETzs7QUFHVCxlQUFBLEdBQWtCLFNBQUE7QUFDaEIsTUFBQTtFQUFBLE9BQUEsR0FBVSxRQUFRLENBQUMsSUFBSSxDQUFDLFlBQWQsQ0FBMkIsY0FBM0I7RUFHVixJQUFHLE9BQUEsS0FBWSxJQUFaLElBQUEsT0FBQSxLQUFrQixJQUFsQixJQUFBLE9BQUEsS0FBd0IsSUFBeEIsSUFBQSxPQUFBLEtBQThCLElBQTlCLElBQUEsT0FBQSxLQUFvQyxJQUFwQyxJQUFBLE9BQUEsS0FBMEMsSUFBMUMsSUFBQSxPQUFBLEtBQWdELElBQWhELElBQUEsT0FBQSxLQUFzRCxJQUF6RDtXQUNFLGtCQURGO0dBQUEsTUFBQTtXQUdFLGtCQUhGOztBQUpnQjs7QUFTbEIsTUFBTSxDQUFDLE9BQVAsR0FBaUIsVUFBQSxHQUVmO0VBQUEsSUFBQSxFQUFNLFNBQUMsRUFBRDtBQUNKLFFBQUE7O01BQUEsS0FBTSxTQUFBLEdBQUE7O0lBQ04sSUFBZSwyREFBZjtBQUFBLGFBQU8sRUFBQSxDQUFBLEVBQVA7O0lBQ0EsU0FBUyxDQUFDLElBQVYsQ0FBZSxFQUFmO0lBRUEsSUFBVSxPQUFWO0FBQUEsYUFBQTs7SUFDQSxPQUFBLEdBQVU7SUFFVixZQUFBLEdBQWU7SUFDZixNQUFPLENBQUEsWUFBQSxDQUFQLEdBQXVCO0lBRXZCLEtBQUEsR0FBUSxDQUFDLENBQUMsS0FBRixDQUNOO01BQUEsTUFBQSxFQUFRLEtBQVI7TUFDQSxDQUFBLEVBQUcsbUJBREg7TUFFQSxTQUFBLEVBQVcscUJBQXFCLENBQUMsSUFBdEIsQ0FBMkIsR0FBM0IsQ0FGWDtNQUdBLFFBQUEsRUFBVSxZQUhWO01BSUEsTUFBQSxFQUFRLFFBQVEsQ0FBQyxJQUFJLENBQUMsWUFBZCxDQUEyQixjQUEzQixDQUFBLElBQThDLElBSnREO01BS0EsUUFBQSxFQUFVLFFBQVEsQ0FBQyxJQUFJLENBQUMsWUFBZCxDQUEyQixlQUEzQixDQUFBLElBQStDLE9BTHpEO01BTUEsT0FBQSxFQUFTLGlCQU5UO0tBRE07V0FTUixDQUFDLENBQUMsU0FBRixDQUFjLENBQUMsZUFBQSxDQUFBLENBQUQsQ0FBQSxHQUFtQixlQUFuQixHQUFrQyxLQUFoRCxDQUF3RCxDQUFDLElBQXpELENBQThELFNBQUE7YUFDNUQsRUFBQSxDQUFPLElBQUEsS0FBQSxDQUFNLG9DQUFOLENBQVA7SUFENEQsQ0FBOUQ7RUFwQkksQ0FBTiJ9
